module.exports = __webpack_public_path__ + "img/home.b7a9c1a3.jpg";